"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledUtilityPageHeading = exports.StyledUtilityPageWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledUtilityPageWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledUtilityPageWrapper", componentId: "sc-1stwjbx" }) `
  margin-bottom: ${(props) => props.theme.spacers.x6};
`;
exports.StyledUtilityPageHeading = styled_components_1.default.h1.withConfig({ displayName: "StyledUtilityPageHeading", componentId: "sc-zzrq8m" }) `
  text-align: ${(props) => { var _a; return (_a = props.align) !== null && _a !== void 0 ? _a : 'left'; }};
  margin-bottom: ${(props) => props.theme.spacers.x3};
  ${(props) => (0, ui_1.getResponsiveTypography)(props.theme.typography, ['x7', 'x9'])}

  ${(props) => (0, ui_1.mq)({
    marginTop: [props.theme.spacers.x3, props.theme.spacers.x12],
})}
`;
